/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Signer, utils } from "ethers";
import type { Provider } from "@ethersproject/providers";
import type {
  IAuctionFactory,
  IAuctionFactoryInterface,
} from "../IAuctionFactory";

const _abi = [
  {
    inputs: [],
    name: "InvalidParams",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "bidAsset",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "askAsset",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "endDate",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "address",
        name: "creator",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "newAuctionAddress",
        type: "address",
      },
    ],
    name: "AuctionCreated",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "bidAsset",
        type: "address",
      },
      {
        internalType: "address",
        name: "askAsset",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "minPrice",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "maxPrice",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "tickWidth",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "priceDenominator",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "endDate",
        type: "uint256",
      },
    ],
    name: "createAuction",
    outputs: [
      {
        internalType: "contract IDualAuction",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
];

export class IAuctionFactory__factory {
  static readonly abi = _abi;
  static createInterface(): IAuctionFactoryInterface {
    return new utils.Interface(_abi) as IAuctionFactoryInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): IAuctionFactory {
    return new Contract(address, _abi, signerOrProvider) as IAuctionFactory;
  }
}
